import { Identifier, maxValue, minValue, required } from 'react-admin';
import { FieldValues } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { WhiteIpAddressesTooltip } from 'shared/mui/Tooltip/WhiteIpAddressesTooltip/WhiteIpAddressesTooltip';
import { IpAddressInput, NumberInput, TextInputIntrospected } from 'shared/react-admin/Inputs';

import { ProvidersShowWhiteIpAddressesMultipleIpInput } from './ProvidersShowWhiteIpAddressesMultipleIpInput';

export interface WhiteIpAddressesFormValues extends FieldValues {
  ip: string;
  mask: string;
  provider: Identifier;
  comment: string;
}

type Props = {
  multiple?: boolean;
};

export const ProvidersShowWhiteIpAddressesForm: React.FC<Props> = ({ multiple }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '4px',
        padding: '24px 24px 0',
      }}
    >
      {multiple ? (
        <ProvidersShowWhiteIpAddressesMultipleIpInput />
      ) : (
        <IpAddressInput
          fullWidth
          label="IP"
          size="small"
          source="ip"
          validate={required()}
          variant="outlined"
        />
      )}
      <NumberInput
        defaultValue={32}
        fullWidth
        label="Маска"
        size="small"
        slotProps={{ input: { endAdornment: <WhiteIpAddressesTooltip /> } }}
        source="mask"
        validate={[minValue(0), maxValue(32)]}
        variant="outlined"
      />
      <TextInputIntrospected
        defaultValue="—"
        fullWidth
        label="Комментарий"
        size="small"
        source="comment"
        variant="outlined"
      />
    </Box>
  );
};
